
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/active-travel",
      function () {
        return require("private-next-pages/active-travel/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/active-travel"])
      });
    }
  